import { useCallback } from "react";
import { useHistory } from "react-router-dom";

export default function useNavigateToContentPanel() {
	const history = useHistory();
	return useCallback((path: string, state?: Record<string, any>) => {
		// Don't navigate if we are already in the same path
		if (path === history.location.pathname) {
			return;
		}
		// Only replace if we are already in a content panel
		if (['/content/tabs', '/content/custom-tabs'].some(path => history.location.pathname.includes(path))) {
			history.replace(path, state ?? history.location.state);
		} else {
			history.push(path, state ?? history.location.state);
		}
	}, [history]);

}